import React from 'react';
import ListPage from '../../base/ListPage.js';
import APILXD from '../../../http/APILXD.js';
import {Modal, message, Popover, Descriptions, Tag} from 'antd';
import HttpTool from "../../../tool/HttpTool";
import styles from "./index.less";
import ModalBase from "../../../components/modalBase";
import ModalDelete from "../../../components/modalDelete/ModalDelete";
import dayjs from 'dayjs';
import Help from "../../../tool/Help";
import TimeHelp from "../../../tool/TimeHelp";

const MB = new ModalBase()
const MD = new ModalDelete()

export default class VipPriceList extends ListPage {
  constructor(props) {
    super(props);
  }

  base_getListConfig() {
    return {
      table: {
        columns: this.getTableColumns(),
        url: APILXD.pricePackageGetList,
        otherParam: {
          //这里要区分是 用户会员 还是 开发者会员
          productType: this.props.productType
        },
      },
      new: {
        defaultValue: '新增价格配置',
        action: () => {
          this.add();
        }
      },
    }
  }

  getAddData(defaultData) {
    let defaultOption = {
      type: "input",
      ver: true,
      reg: /^[\S\s]{0,50}$/,
      verMessage: "请填写，最多50个字符",
      required: true,
    };

    let monthLimit = defaultData?Help.getDurationTimeUse(defaultData.monthLimit, defaultData.monthLimitUnit):undefined;

    let props = {
      colCount: 1,
      formItemLayout: {
        labelCol: {span: 4},
        wrapperCol: {span: 18, offset: 0},
      },
      parameterArr: [
        {
          ...defaultOption,
          field: "monthLimit",
          name: "会员时长",
          col: 2,
          formItemLayout: {
            labelCol: {span: 12},
            wrapperCol: {span: 12, offset: 0},
          },
          type: 'inputNumber',
          reg: (v)=>{
            return typeof v === 'number' && v>=1
          },
          verMessage: '请输入时长，1-12',
          option: {
            max: 12,
            min: 1,
            defaultValue: monthLimit,
            style: {width: '100%'},
          }
        },
        {
          ...defaultOption,
          field: "monthLimitUnit",
          name: "",
          col: 2,
          formItemLayout: {
            labelCol: {span: 12},
            wrapperCol: {span: 12, offset: 0},
          },
          type: 'Select',
          selectType: 'value',
          reg: (v)=>{
            return !!v
          },
          verMessage: "请选择时长单位",
          option: {
            style: {width: '120px'},
            defaultValue: defaultData?.monthLimitUnit?{
              key: defaultData?.monthLimitUnit,
              value: defaultData?.monthLimitUnit,
            }:null,
          },
          data: [
            {
              title: '月',
              value: '月'
            },
            {
              title: '季度',
              value: '季度'
            },
            {
              title: '年',
              value: '年'
            }
          ]
        },
        {
          ...defaultOption,
          field: "priceSet",
          name: "价格",
          type: 'inputNumber',
          reg: (v)=>{
            return typeof v === 'number' && v>=0.01
          },
          verMessage: '请输入价格，1-999999',
          option: {
            max: 999999,
            min: 0.01,
            defaultValue: defaultData?.price/100,
            style: {width: '100%'},
            addonAfter: '灵能',
          }
        },
        {
          ...defaultOption,
          field: "targetTag",
          name: "适用用户",
          type: 'Select',
          selectType: 'value',
          verMessage: "请选择适用用户",
          reg: (v) => {
            return !!v
          },
          option: {
            defaultValue: defaultData?.targetTag ? {
              key: defaultData.targetTag,
              value: defaultData.targetTag,
            } : null
          },
          apiConfig: {
            url: APILXD.pricePackageTargetTag,
            fillObject: (json) => {
              return json?.map((item) => {
                return {
                  title: item.desc,
                  value: item.code
                }
              });
            }
          },
        },
        {
          ...defaultOption,
          field: "eventTimeSet",
          name: "会员活动期",
          type: 'RangePicker',
          required: false,
          reg: () => {
            return true
          },
          option: {
            style: {width: "100%"},
            defaultValue: (defaultData && defaultData?.eventEndTime) ? [dayjs(defaultData?.eventStartTime), dayjs(defaultData?.eventEndTime)] : null,
            disabledDate: (value) => {
              if (!value) {
                return false;
              }
              let nowDate = new Date();
              return value.valueOf() < nowDate.valueOf() - 86400000;
            },
          }
        },
        {
          ...defaultOption,
          field: "tagList",
          name: "价格标签",
          type: 'SelectAll',
          selectType: 'value',
          required: false,
          reg: (v) => {
            if(!v?.length){
              return true
            }

            return !(v.some((item) => {return item.length>5}))
          },
          verMessage: "每个标签最多使用5个字符",
          option: {
            mode: 'tags',
            placeholder: "请输入标签内容",
            maxLength: 50,
            onSearch: (v) => {
            },
            defaultValue: defaultData?.tagList?.length ? defaultData?.tagList.map((name) => {
              return {
                label: name,
                value: name,
              }
            }) : null
          },
        },
        {
          ...defaultOption,
          field: "remark",
          name: "会员说明",
          type: 'TextArea',
          required: false,
          reg: (v) => {
            return true
          },
          option: {
            maxLength: "1000",
            defaultValue: defaultData?.remark
          }
        },
      ],
    };
    return {
      props,
      otherParam: null
    }
  }

  add(defaultValue) {
    let addData = this.getAddData(defaultValue);
    MB.show(
      {
        title: defaultValue?"编辑价格配置":"新增价格配置",
        okTitle: "确定",
        closeTitle: "取消",
        zIndex: 999999,
      },
      addData.props
      ,
      {
        otherParam: defaultValue?{
          productType: this.props.productType,
          _id: defaultValue._id
        }:{
          productType: this.props.productType
        },
        url: defaultValue ? APILXD.pricePackageEdit : APILXD.pricePackageAdd,
        beforeSubmit: (param) => {
          //设置了活动期限
          if (param.eventTimeSet?.length) {
            param.eventStartTime = dayjs(param.eventTimeSet[0]).valueOf();
            param.eventEndTime = dayjs(param.eventTimeSet[1]).valueOf();
          }

          if(param.tagList?.length){
            param.tagList =  param.tagList.map((item)=>{
              return typeof item === "string" ? item : item.value;
            });
          }

          param.monthLimit = Help.getDurationTimeMonth(param.monthLimit, param.monthLimitUnit);
          param.price = Math.round(param.priceSet * 100);

          return true;
        },
        callBack: (state, msg) => {
          //添加成功回调
          state == 'success' && this._loadDataForNet();
        }
      });
  }

  /**
   *  列表数据配置
   */
  getTableColumns() {
    return [
      {
        title: '会员时长',
        dataIndex: 'duration',
        key: 'duration',
        render: (text, record)=>{
          return Help.getDurationTimeShow(record.monthLimit, record.monthLimitUnit)
        }
      },
      {
        title: '说明',
        dataIndex: 'remark',
        key: 'remark',
        render: (text, record)=>{
          return <Popover
            title={"会员说明"}
            content={text}
          >
            查看
          </Popover>
        }
      },
      {
        title: '价格(灵能)',
        dataIndex: 'price',
        key: 'price',
        render: (text, record)=>{
          return text?text/100 : 0
        }
      },
      {
        title: '活动范围',
        dataIndex: 'duration',
        key: 'duration',
        render: (text, record, index) => {
          return <div>
            <div>适用用户：{record.targetTagDesc}</div>
            <div>期限：{record.eventEndTime?<span>
              {TimeHelp.getYMDFormat(record.eventStartTime, 'yyyy.MM.dd')}
              -
              {TimeHelp.getYMDFormat(record.eventEndTime, 'yyyy.MM.dd')}
            </span>:<span>无限期</span>}</div>
          </div>
        }
      },
      {
        title: '标签',
        dataIndex: 'tagList',
        key: 'tagList',
        render: (text) => {
          return <div style={{maxWidth: '350px'}}>
            {
              text?.map((str)=>{
                return <Tag key={str}>{str}</Tag>
              }) || '-'
            }
          </div>
        }
      },
      {
        title: '状态',
        dataIndex: 'enable',
        key: 'enable',
        render: (text) => {
          return text ? <span style={{color: 'dodgerblue'}}>已上架</span> :
            <span style={{color: 'darkorange'}}>已下架</span>
        }
      },
      {
        title: '已售数量',
        dataIndex: 'count',
        key: 'count',
        render: (text) => {
          return text || 0
        }
      },
      {
        title: '操作',
        width: 220,
        render: (text, record, index) => {
          return (
            <div>
              {
                this.powerConfig.Edit
                  ? (record.enable ? <span onClick={() => {
                      this.changeState(record._id, false)
                    }} style={{color: "darkorange"}} className={styles.btnCopy}>{"下架"}</span> :
                    <span onClick={() => {
                      this.changeState(record._id, true)
                    }} style={{color: "dodgerblue"}} className={styles.btnEdit}>{"上架"}</span>)
                  : null
              }
              {
                this.powerConfig.Edit
                  ?  <span onClick={() => {
                    this.add(record)
                  }} className={styles.btnEdit}>{"修改"}</span>
                  : null
              }
              {
                this.powerConfig.Delete && !record.enable
                  ?  <span onClick={() => {
                    MD.show({
                        title: "提示",
                        okTitle: "确定",
                        closeTitle: "取消",
                        zIndex: 999999,
                      },
                      {}
                      ,
                      {
                        otherParam: {_id: record._id},
                        content: record.name,
                        url: APILXD.pricePackageDel,
                        apiType: 'post',
                        callBack: (state) => {
                          //删除成功回调
                          if(state === "success"){
                            if(this.items?.length === 1 && this.state.page > 1){
                              //当前页的最后一条
                              this.setState({
                                page: this.state.page - 1
                              },()=>{
                                this._loadDataForNet();
                              })
                            }else{
                              this._loadDataForNet();
                            }
                          }
                        }
                      });
                  }} className={styles.btnDelete}>{"删除"}</span>
                  : null
              }
            </div>
          )
        }
      },
    ]
  }

  changeState(id, enable) {
    Modal.confirm({
      title: '提示',
      content: "确定" + (enable ? "上线" : "下线") + "该价格配置吗？",
      okText: '确定',
      cancelText: '取消',
      onOk: () => {
        let param = {
          _id: id,
          enable,
        };
        let successCB = (code, msg, json, option) => {
          this.setState({loading: false}, () => {
            message.success('操作成功');
            this._loadDataForNet();
          });
        };
        let failureCB = (code, msg) => {
          this.setState({loading: false}, () => {
            message.error(msg);
          });
        };

        this.setState({loading: true});

        HttpTool.post(APILXD.pricePackageDisable, successCB, failureCB, param);
      }
    })
  }
}